/**
 * Toggle Control Component
 * Renders on/off toggle switch
 */

import React from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { ToggleSettings } from '../../../../types/ControlTypes';
import { LabelWithInfo } from './LabelWithInfo';

export const ToggleControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as ToggleSettings;
  const toggleLabel = settings?.label || label || name;

  return (
    <Box sx={{ mb: 2 }}>
      {description && (
        <Box sx={{ mb: 1 }}>
          <LabelWithInfo
            label={label || name}
            description={description}
            required={required}
          />
        </Box>
      )}
      
      <FormControlLabel
        control={
          <Switch
            checked={value === true || value === 'true'}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled || readonly}
            color="primary"
          />
        }
        label={toggleLabel}
      />
      
      {error && <Box sx={{ color: '#d32f2f', fontSize: '12px', mt: 0.5 }}>{error}</Box>}
    </Box>
  );
};

export default ToggleControl;
